import Spacer from 'components/core/Spacer/Spacer';

import { AlreadyHost } from 'components/views/pages/list/components/AlreadyHost';
import React from 'react';

import { ListPageUserSignUpModal } from 'components/views/pages/list/modal/ListPageUserSignUpModal';
import { ReactQueryDevtools } from 'react-query/devtools';

import { useToggle } from '@alluradirect/react';
import { Divider } from '@mui/material';
import { Page } from 'components/layout/Page/Page';
import { CalendarSync } from 'components/views/pages/list/components/CalendarSync';
import { CheckinGuidebook } from 'components/views/pages/list/components/CheckinGuidebook';
import { ClientsLoveAllura } from 'components/views/pages/list/components/ClientsLoveAllura';
import { ConnectedMobileApp } from 'components/views/pages/list/components/ConnectedMobileApp';
import { DirectBookingSite } from 'components/views/pages/list/components/DirectBookingSite';
import { FeaturesBenefits } from 'components/views/pages/list/components/FeaturesBenefits';
import { FullBarGetStarted } from 'components/views/pages/list/components/FullBarGetStarted';
import { FullBarManager } from 'components/views/pages/list/components/FullBarManager';
import { GetListed24Hours } from 'components/views/pages/list/components/GetListed24Hours';
import { GetStartedCard } from 'components/views/pages/list/components/GetStartedCard';
import { HeroHeader } from 'components/views/pages/list/components/HeroHeader';
import { HowWeAreDifferent } from 'components/views/pages/list/components/HowWeAreDifferent';
import { JoinMarketplace } from 'components/views/pages/list/components/JoinMarketplace';
import { MarketingPartners } from 'components/views/pages/list/components/MarketingPartners';
import { MembershipPricing } from 'components/views/pages/list/components/MembershipPricing';
import { PayoutsTaxes } from 'components/views/pages/list/components/PayoutsTaxes';
import { TopNavLinks } from 'components/views/pages/list/components/TopNavLinks';
import UserTestimonials from 'components/views/pages/list/components/UserTestimonials';
import { WorksOtherHosting } from 'components/views/pages/list/components/WorksOtherHosting';
import { YouAreInControl } from 'components/views/pages/list/components/YouAreInControl';
import {
  listFormContextInitialValues,
  ListModalContextProvider,
} from 'components/views/pages/list/modal/listModalContext';
import { ContentWrapper } from 'components/views/pages/list/components/styles';
import { useResortsQuery } from 'hooks/api/location/useResortsQuery';
import { Footer } from 'scenes/dashboard/components/LeftNavContent/styles';
import { AlluraErrorBoundary } from 'components/core/AlluraErrorBoundary/AlluraErrorBoundary';
import { FullScreenErrorFallback } from 'components/core/AlluraErrorBoundary/components/FullScreenErrorFallback';
import { useListPageModalNavigation } from 'components/views/pages/list/modal/hooks/useListPageModalNavigation';
import { PageHeaderHelpDialog } from 'components/layout/Page/components/PageHeaderHelpDialog';
import { ListFooterBar } from './components/ListFooterBar';
import { listProperty } from 'config/imageUrls';

export const ListBase = () => {
  const listModalToggle = useToggle();
  // Load the Resorts when the page is rendered so that the modal data is loaded.
  // In the next phase of this project, we will be able to prime React Query in production
  // by loading these variables on the server side and injecting them into RQ.
  useResortsQuery();
  const helpToggle = useToggle();

  const [listFormValues, setListFormValues] = React.useState(listFormContextInitialValues);
  const { pushDefaultUrl, isFormTypeInRouterQuery, isStepInRouterQuery } = useListPageModalNavigation();
  React.useEffect(() => {
    // Ensure that the url param is set to the correct step.
    // This ensures that we always have a stable url state when accessing the modal.
    if (!isStepInRouterQuery || !isFormTypeInRouterQuery) {
      pushDefaultUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page hasHeader={false} appSEOProps={{ description: 'Get listed on alluraDirect today by signing up for free.', title: 'List your vacation rental property', image: listProperty }}>
      <ContentWrapper>
        <TopNavLinks openModal={listModalToggle.open} />
        <HeroHeader openModal={listModalToggle.open} openHelpModal={helpToggle.open} />

        <Spacer />

        <AlreadyHost openModal={listModalToggle.open} />

        <JoinMarketplace />
        <Divider />

        <GetListed24Hours openModal={listModalToggle.open} />
        <Divider />

        <WorksOtherHosting />
        <Divider />

        <HowWeAreDifferent />

        <FullBarManager onClick={helpToggle.open} />

        <FeaturesBenefits />
        <Divider />

        <CalendarSync />

        <YouAreInControl />

        <PayoutsTaxes />
        <Divider />

        <DirectBookingSite />

        <ConnectedMobileApp />

        <FullBarGetStarted onClick={listModalToggle.open} />

        <CheckinGuidebook />

        <MarketingPartners />
        <Divider />

        <ClientsLoveAllura />
        <Divider />

        <UserTestimonials />
        <Divider />
        <AlluraErrorBoundary Fallback={FullScreenErrorFallback}>
          <MembershipPricing />
        </AlluraErrorBoundary>

        <GetStartedCard openModal={listModalToggle.open} />

        <FullBarGetStarted onClick={listModalToggle.open} />

        <ListFooterBar />

        <Footer />
      </ContentWrapper>

      {/* MODALS - NEEDS FIXING FOR TOGGLE */}
      {listModalToggle.isOpen ? (
        <ListModalContextProvider value={{ listFormValues, setListFormValues }}>
          <ListPageUserSignUpModal closeModal={listModalToggle.close} isOpen={listModalToggle.isOpen} />
        </ListModalContextProvider>
      ) : null}
      {helpToggle.isOpen ? <PageHeaderHelpDialog isOpen={helpToggle.isOpen} close={helpToggle.close} /> : null}
      <ReactQueryDevtools initialIsOpen={false} />
    </Page>
  );
};
